import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseCoreState, baseInquirySelectors, baseInquiryActions } from '../../_store';
import { BaseInquiriesPayloadInterface } from '../../modules/inquiry/_interfaces/base-inquiries-payload.interface';

@Injectable({ providedIn: 'root' })
export class BaseCustomerInquiryListGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(
      baseInquiryActions.getInquiries({
        payload: route.queryParams as BaseInquiriesPayloadInterface,
      })
    );

    return this.store.select(baseInquirySelectors.getInquiries).pipe(
      filter((result) => result.ok !== undefined),
      map((result) => !!result.ok)
    );
  }
}
